import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import styles from "../../stripe-dashboard.module.css";

function PlanDistributionChart({ data }) {
  const chartData = Array.isArray(data) ? data : [];

  return (
    <div className={styles.chartCard}>
      <p className={styles.chartTitle}>Distribuição de Planos</p>

      {chartData.length === 0 ? (
        <div className={styles.loadingWrap} style={{ minHeight: 200 }}>
          <span style={{ color: "#94a3b8" }}>Sem dados</span>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            layout="vertical"
            margin={{ top: 8, right: 12, left: 0, bottom: 8 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
            <XAxis
              type="number"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 11, fill: "#94a3b8" }}
            />
            <YAxis
              type="category"
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 11, fill: "#94a3b8" }}
              width={140}
            />
            <Tooltip
              contentStyle={{
                background: "#0f172a",
                border: "none",
                borderRadius: 8,
                fontSize: 12
              }}
              labelStyle={{ color: "rgba(255,255,255,0.6)" }}
              itemStyle={{ color: "#fff" }}
              formatter={(v) =>
                new Intl.NumberFormat("pt-BR").format(v)
              }
            />
            <Bar
              dataKey="value"
              fill="#035184"
              radius={[0, 4, 4, 0]}
              barSize={14}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}

export default PlanDistributionChart;

